import { render, staticRenderFns } from "./ModalInformativo.vue?vue&type=template&id=56b7d307&"
import script from "./ModalInformativo.vue?vue&type=script&lang=ts&"
export * from "./ModalInformativo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInformativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports